// Helper functions shared across venue detail components

export const isMobilePhone = (number) => {
  if (!number) return false;
  const cleaned = number.replace(/\D/g, '');
  return (
    (cleaned.startsWith('05') && cleaned.length === 11) ||
    (cleaned.startsWith('5') && cleaned.length === 10) ||
    (cleaned.startsWith('905') && cleaned.length === 12)
  );
};

export const formatWhatsAppNumber = (number) => {
  if (!number) return '';
  let cleaned = number.replace(/\D/g, '');
  if (cleaned.startsWith('0')) {
    cleaned = '90' + cleaned.substring(1);
  }
  if (!cleaned.startsWith('90')) {
    cleaned = '90' + cleaned;
  }
  return cleaned;
};

export const isPremiumPlan = (venue) => {
  if (!venue) return false;
  const plan = venue.currentPlan?.toLowerCase();
  return plan === 'pro' || plan === 'premium';
};

export const isVenueClaimed = (venue) => {
  if (!venue) return false;
  return venue.isClaimed === true || 
         (venue.ownerId && venue.ownerId !== '') || 
         isPremiumPlan(venue);
};

export const getEmbedUrl = (url) => {
  if (!url) return null;
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const videoId = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    if (videoId) return `https://www.youtube.com/embed/${videoId[1]}`;
  }
  if (url.includes('vimeo.com')) {
    const videoId = url.match(/vimeo\.com\/(\d+)/);
    if (videoId) return `https://player.vimeo.com/video/${videoId[1]}`;
  }
  return null;
};

export const turkishToEnglish = (str) => {
  return str.toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/\s+/g, '-');
};
